import React, { useEffect, useRef, useState } from 'react';
import Button from '../../../components/controls/button';
import Style from './MfaChallenge.module.css';
import { useHistory } from 'react-router';
import { isValidEmail } from '../../../utils/formValidation';
import { useSelector } from 'react-redux';
import CustomInput from "../../../components/controls/input/customInput/CustomInput";
import HanshiWhiteLogo from '../../../assets/hanshi/full-white-sm.svg';
import { ArrowLeft } from "../../../modules/default-svg";
import PinInput from 'react-pin-input';
import { clearMfaTempData } from '../../../utils/cookieUtils';
import { useDispatch } from "react-redux";
import { generalActions } from '../../../store/actions';

const MfaChallenge = (props) => {
  const {
    loginRequest,
    authError,
    isLoading,
    mfaTempData
  } = props;

  const [errorMessage, setErrorMessage] = useState('');
  const dispatch = useDispatch();
  const pinCodeRef = useRef();
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
      if (token) {
        history.push(`/dashboard`);
      }
    }, [token]);
    
  useEffect(() => {
    if(!mfaTempData){
      history.push('/');
    }
    else{
      pinCodeRef.current.focus();
    }
  },
  [mfaTempData]);

  useEffect(() => {
    if(authError?.code == 429){
      clearMfaTempData();
      dispatch(
              generalActions.showToast({
                title: authError?.error,
                type: 'error',
              })
            );
      history.push('/');
    }
    setIsInputDisabled(false);
    setCode('');
    pinCodeRef?.current?.clear();
    pinCodeRef?.current?.focus();
    setErrorMessage(authError?.error);
  },
  [authError]);
  const history = useHistory();
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [code, setCode] = useState('');
  const [isValidCode, setIsValidCode] = useState(false);
  
  const handleCodeCompleted = (code) =>{
    setCode(code);
    setIsInputDisabled(true);
    handleVerifyMfa(code);
  }

  const handleVerifyMfa = (code) => {
    loginRequest({
      isVerifyMfa: true,
      tempToken: mfaTempData?.token,
      code: code,
      domain: mfaTempData?.domain,
    });
  }

  const handleCodeChanged = (code) =>{
    const isValid = /^\d{6}$/.test(code);
    setIsValidCode(isValid);
  }

  const handleBack = () =>{
    clearMfaTempData();
    history.push('/');
  };

  return (
    <div className={Style.mainWrapper}>
      <div className={Style.card}>
        <div className="w-full flex justify-center pt-10 mb-5">
          <img src={HanshiWhiteLogo} alt="Hanshi Logo" className="w-32 md:w-48" />
        </div>
        <div className={Style.cardContent}>
          <div className={Style.cardTitleContainer}>
            <p className={`${Style.cardTitle}`}>Multi-factor Authentification</p>
            <p className={`${Style.cardDescription}`}>Enter the code from your multi-factor authentication app</p>
          </div>
          <div>
            <div className={`${Style.codeFieldWrapper} row`}>
              <PinInput
                ref={pinCodeRef}
                length={6}
                type="numeric" 
                inputMode="number"
                inputStyle={{ borderColor: '#808D9E', borderRadius:'4px', color:'white'}}
                inputFocusStyle={{borderColor: '#342c82'}}
                autoSelect={true}
                focus={true}
                disabled={isInputDisabled}
                onComplete={(val,idx) =>{handleCodeCompleted(val)}}
                onChange={(val,idx) =>{handleCodeChanged(val)}} 
              />
              <p class="Input_errorMessage">{errorMessage}</p>
            </div>
          </div>
        </div>
        <div className={Style.btnWrapper}>
          <Button 
            btnClass={`btn_w100 btn_w100_primary ${!isValidCode && 'opacity-50'}`} 
            label="Verify" 
            clickHandler={handleVerifyMfa} 
            showLoading={isLoading} 
            isDisabled={isLoading || !isValidCode} />
           <div
              className="d-flex align-items-center"
          >
              <ArrowLeft />
              <p className="my-3 text-xsm-500 text-[#5e5e5e] hover:text-[#342c82] hover:cursor-pointer" onClick={handleBack}>
                  Back to Sign In
              </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MfaChallenge;